import React, { useEffect, useState } from "react";
import Header from "../../../Componets/Header";
import { useLocation } from "react-router-dom";
import inventory from "../../../Data/inventory.json";
import products from "../../../Data/products.json";
import { get_all_inventories } from "../../../Controllers/Inventory/Batch";
import toast from "react-hot-toast";
import moment from "moment";
import Loadercomponent from "../../../Componets/Loader";
import { get_all_inventories_reports } from "../../../Controllers/Dashboard/Dashboard";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import formatDateDDMMYYYY from "../../../Main/formatDate";
import { useRef } from "react";
import ReactToPrint from "react-to-print";
import { Button } from "antd";
import StockFL from "../../../Componets/FormatStock";

const InventoryReportDashboard = () => {
  let location = useLocation();

  const [loader, setLoader] = useState(false);
  const [body, setBody] = useState();
  const Dashboard_Branch = localStorage.getItem("Dashboard_Branch");
  const componentRef = useRef();

  const headers = {
    name: "Inventory batch",
    pagination: {
      currentPage: 1,
      totalCount: 0,
      totalPages: 0,
    },
    components: [
      {
        type: "search",
        name: "search",
        placeholder: "Search",
        value: "",
      },
      {
        type: "select",
        name: "sort",
        placeholder: "Sort",
        value: null,
        allowClear: true,
        options: [
          { value: 1, label: "Name [A-Z]" },
          { value: 2, label: "Name [Z-A]" },
          { value: 7, label: "Sale (Low)" },
          { value: 8, label: "Sale (High)" },
          { value: 9, label: "Stock (Low)" },
          { value: 10, label: "Stock (High)" },
          { value: 11, label: "Expiry (ASC)" },
          { value: 12, label: "Expiry (DES)" },
        ],
      },
      {
        type: "filter",
        name: "product",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Product",
        api: "get-all-products",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "supplier",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Supplier",
        api: "get-all-suppliers",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "purchase",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Purchase",
        api: "get-all-purchase-orders",
        value: null,
        options: null,
      },
      {
        type: "filter",
        name: "branch",
        allowClear: true,
        showSearch: true,
        filterOption: false,
        placeholder: "Branch",
        api: "get-all-branches",
        value: null,
        options: null,
      },
      {
        type: "range",
        name: "date",
        value: {
          start: "",
          end: "",
        },
      },
    ],
  };

  const [header, setHeader] = useState(headers);

  const [total, setTotals] = useState(0);

  const formdata = (data) => {
    fetchData(data);
  };

  const fetchData = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        sort: tabledata?.sort,
        product: tabledata?.product,
        supplier: tabledata?.supplier,
        purchase: tabledata?.purchase,
        branch: tabledata?.branch ? tabledata?.branch : Dashboard_Branch,
        date: tabledata?.date,
      };

      const products = await get_all_inventories_reports(data);
      if (products?.status) {
        setBody(products?.data?.data);
        setLoader(false);
        setTotals(products?.data?.grand_total);
      } else {
        toast?.error(products?.message);
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // let total_purchase = 0;

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="flex justify-end mt-4">
          <ReactToPrint
            trigger={() => (
              <Button
                type="primary"
                className="!bg-[#0dacce] !border-[#0dacce] hover:!bg-[#0b9abb]"
              >
                Print
              </Button>
            )}
            content={() => componentRef.current}
            pageStyle={`
              @page {
                size: A4 landscape;
                margin: 10mm;
              }

              @media print {
                body {
                  -webkit-print-color-adjust: exact;
                  print-color-adjust: exact;
                }

                table {
                  width: 100%;
                  border-collapse: collapse;
                  font-size: 11px;
                }

                th, td {
                  border: 1px solid #000 !important;
                  padding: 6px;
                }

                thead {
                  display: table-header-group;
                }

                tfoot {
                  display: table-row-group;
                }
              }
  `         }
          />

        </div>

        <ScrollWrapper summary={2}>
          <div ref={componentRef}>
            <table className="w-full bg-white mt-4">
              <thead className="text-gray-500">
                <tr>
                  <td className="border p-4">S.No</td>
                  <td className="border p-4">Name</td>
                  <td className="border p-4">Batch</td>
                  {/* <td className="border p-4">Supplier</td> */}
                  {/* <td className="border p-4">Purchase</td> */}
                  <td className="border p-4">Branch</td>
                  <td className="border p-4">Expiry</td>
                  <td className="border p-4">Tax</td>
                  {/* <td className="border p-4">Purchase</td> */}
                  {/* <td className="border p-4">Price/unit</td> */}
                  <td className="border p-4">Sale</td>
                  {/* <td className="border p-4">Margin</td> */}
                  <td className="border p-4">Stock(Full | Loose)</td>
                  {/* <td className="border p-4">Total</td> */}
                </tr>
              </thead>
              <tbody>
                {body?.map((value, index) => {
                  return (
                    <tr>
                      <td className="border p-4">{index + 1}</td>
                      <td className="border p-4">{value?.product?.name}</td>
                      <td className="border p-4">#BATCH&nbsp;{value?.number}</td>
                      {/* <td className="border p-4">{value?.supplier?.name}</td> */}
                      {/* <td className="border p-4">
                    {value?.purchase?.number
                      ? `#PO${value?.purchase?.number}`
                      : ""}
                  </td> */}
                      <td className="border p-4">{value?.branch?.name}</td>
                      <td className="border p-4">
                        {value?.expiry_date
                          ? formatDateDDMMYYYY(value?.expiry_date)
                          : ""}
                      </td>
                      <td className="border p-4">{value?.tax?.rate || 0}</td>
                      {/* <td className="border p-4">
                    {value?.purchase_price?.toFixed(3)}
                  </td> */}
                      {/* <td className="border p-4">
                    {value?.price_per_unit?.toFixed?.(3)}
                  </td> */}
                      <td className="border p-4">
                        {value?.sale_price?.toFixed(3)}
                      </td>
                      {/* <td className="border p-4">{value?.margin?.toFixed(3)}%</td> */}
                      <td className="border p-4">
                        <StockFL
                          totalStock={value?.stock}
                          conversion={
                            value?.product_units_details?.[0]?.conversion || 1
                          }
                        />
                      </td>
                      {/* <td className="border p-4">{value?.total?.toFixed?.(3)}</td> */}
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <td className="border p-4"></td>
                <td className="border p-4"></td>
                <td className="border p-4"></td>
                {/* <td className="border p-4"></td> */}
                {/* <td className="border p-4"></td> */}
                <td className="border p-4"></td>
                <td className="border p-4"></td>
                {/* <td className="border p-4"></td> */}
                {/* <td className="border p-4"></td> */}
                <td className="border p-4">
                  {/* {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.stock),
                  0
                )
                ?.toFixed(3)} */}
                </td>
                {/* <td className="border p-4">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.purchase_price),
                  0
                )
                ?.toFixed(3)}
            </td> */}
                {/* <td className="border p-4">
              {body
                ?.reduce(
                  (acc, currentValue) =>
                    parseFloat(acc) + parseFloat(currentValue?.price_per_unit),
                  0
                )
                ?.toFixed?.(3)}
            </td> */}
                <td className="border p-4">
                  {body
                    ?.reduce(
                      (acc, currentValue) =>
                        parseFloat(acc) + parseFloat(currentValue?.sale_price),
                      0
                    )
                    ?.toFixed?.(3)}
                </td>
                <td className="border p-4">
                  {body
                    ?.reduce(
                      (acc, currentValue) =>
                        parseFloat(acc) + parseFloat(currentValue?.stock),
                      0
                    )
                    ?.toFixed?.(3)}
                </td>
                {/* <td className="border p-4">{total?.toFixed(3)}</td> */}
              </tfoot>
            </table>
          </div>

        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default InventoryReportDashboard;
